<template>
  <button
    :type="type"
    class="button-base"
    :class="{'w-100': full}"
    @click="$emit('click'); $emit('clicked')"
    :disabled="disabled"
  >
    <slot />
    
    <span v-if="icon === 'arrow-right'">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
        <path d="M12.175 9.95117H0V7.95117H12.175L6.575 2.35117L8 0.951172L16 8.95117L8 16.9512L6.575 15.5512L12.175 9.95117Z" fill="#F0F0F0"/>
      </svg>
    </span>
  </button>
</template>

<script>
  export default {
    props: {
      type: {
        type: String,
        default: 'button'
      },

      full: {
        type: Boolean,
        default: false,
      },

      active: {
        type: Boolean,
        default: false,
      },

      disabled: {
        type: Boolean,
        default: false
      },

      icon: {
        type: String,
      },
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .button-base {
    display: flex;
    padding: 12px 24px;
    justify-content: center;
    align-items: center;
    gap: 16px;
    color: $white300;
    font-size: 0.89rem;
    transition: .5s all;
    border-radius: 4px;
    border: 1px solid rgba(255, 222, 91, 0.10);
    background: radial-gradient(56.27% 117.62% at 37.5% 100%, rgba(255, 255, 255, 0.29) 0%, rgba(255, 255, 255, 0.05) 100%), radial-gradient(108.23% 146.28% at 50% 0%, rgba(32, 32, 32, 0.00) 11.38%, rgba(91, 0, 105, 0.70) 68.27%), radial-gradient(178.09% 220.16% at 94.89% -132.81%, #9000F0 67.59%, rgba(253, 212, 155, 0.38) 100%), #000;
    box-shadow: 0px 0px 4px 0px #FFF inset;
    
    &:hover {
      border: 1px solid rgba(255, 222, 91, 0.05);
      background: radial-gradient(56.27% 117.62% at 37.5% 100%, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.02) 100%), radial-gradient(108.23% 146.28% at 50% 0%, rgba(32, 32, 32, 0.00) 11.38%, rgba(91, 0, 105, 0.70) 68.27%), radial-gradient(178.09% 220.16% at 94.89% -132.81%, #9000F0 67.59%, rgba(253, 212, 155, 0.38) 100%), #000;
    }

    &:focus {
      border: 1px solid rgba(255, 222, 91, 0.01);
      background: radial-gradient(108.23% 146.28% at 50% 0%, rgba(32, 32, 32, 0.00) 11.38%, rgba(91, 0, 105, 0.70) 68.27%), radial-gradient(178.09% 220.16% at 94.89% -132.81%, rgba(144, 0, 240, 0.70) 67.59%, rgba(253, 212, 155, 0.27) 100%), #000;
      box-shadow: 0px 0px 4px 0px rgba(255, 255, 255, 0.60) inset;
    }
  }
</style>